<sn-camera-stream-view
  #cameraStreamView
  [camera]="camera"
  [canEdit]="canEdit"
  [actions]="actions"
  [autoplay]="autoplay"
  [controls]="controls"
  [alwaysOn]="alwaysOn"
  [timestamp]="timestamp"
  [allowTimeout]="allowTimeout"
  [camTime]="camTime"
  [pauseOnTimeChange]="pauseOnTimeChange"
  (streamPlay)="onCameraStreamPlay($event)"
  (streamPause)="onCameraStreamStop()"
  (streamStop)="onCameraStreamStop()"
  (stateChange)="onStateChange($event)"
  (selectedTime)="selectedTime.next($event)"
>
</sn-camera-stream-view>
